module.exports = __webpack_public_path__ + "static/media/pencil.fa8188a6.png";